export default {
  GET_CATEGORIES: (state) => state.categories,
  GET_PRODUITS: (state) => state.produits,
  GET_CONFIG: (state) => state.config,
  GET_USERS: (state) => state.users,
  GET_SELL_PRODUCTS: (state) => state.products,
  GET_CART: (state) => state.cart,
  GET_CURRENT_CLIENT: (state) => state.client,
  GET_SELLER_REPORTS: (state) => state.seller_reports,
  IS_LOADING: (state) => state.dataLoading,
  GET_SESSION: (state) => state.session,
};
